<template>
  <div class="container map" :style="styles1">
    <div class="wraps">
      <div class="center">
        <div class="tops">
          <div class="map-container" :style="styles">
             <t-map1 ref="map"  :data="resData" :loading.sync="loading"></t-map1>
          </div>
        </div>
      </div>
      <div class="copy" v-if="!nocopy">由快递鸟提供技术支持</div>
    </div>
  </div>
</template>

<script>
import tMap from '@/components/map.vue'
import tMap1 from '@/components/map1.vue'
export default {
  props: {},
  components: {
    tMap,
    tMap1
  },
  data() {
    return {
      checked: true,
      show: false,
      loading: false,
      DataSign: "",
      AppKey: process.env.VUE_APP_APPKEY,
      params: {},
      time: 1000 * 60 * 30,
      timer: null,
      form: {
        RequestData: {
          Code:""
        },
        DataSign: "",
        EBusinessID: process.env.VUE_APP_EBUSINESSID,
        RequestType: "8006",
        DataType: "2",
      },
      tableData: [],
      resData: {},
      flag: false,
      nocopy:null,
      styles:{},
      styles1:{},
      times:null,
      times1:null,
      query:this.$route.query
    };
  },
  created() {
    this.setCss();
  },
  mounted() {
    this.getData()
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
    setCss(){
      let width = this.$route.query.width;
      let height=this.$route.query.height;
      let wCss={}
      if(height){
        if(height.indexOf("px")<0&&height.indexOf("vh")<0){
          if(Number(height)){
            height = Number(height)+"px"
          }
        }
      }
      this.styles={
        height
      }
      if(width){
        if(width.indexOf("px")<0){
          if(Number(width)){
            width = Number(width)+"px"
          }
        }
        wCss={
          width,
          maxWidth:'100%',
          padding:0
        }
      }
      this.styles1={
        ...wCss
      }
    },
    getData() {
      this.nocopy = this.$route.query.nocopy;
      this.times=this.$tool.formatDate(new Date().getTime()-100*3600*1000)
      this.times1=this.$tool.formatDate(new Date().getTime()+100*3600*1000)
      let state=this.$route.query.state||2;
      let data = {
        "CityIsNull":false,
        "PreCoordinates" : [  {
          "LatAndLng" : "22.55329,113.88308",
          "Location" : "深圳市"
        },{
          "LatAndLng" : "31.40527,121.48941",
          "Location" : "上海市"
        }],
        "EstimatedDeliveryTime" : this.times1,
        "Traces" : [ {
        "Action" : "1",
        "AcceptStation" : "深圳市福田区 揽收成功",
        "AcceptTime" : this.times,
        "Location" : "深圳市"
         } , {
          "Action" : "1",
          "AcceptStation" : "深圳市福田区发往下一站 东莞市",
          "AcceptTime" : this.times,
          "Location" : "东莞市"
        }],
        "State" : state,
        "StateEx":"2",
        "Coordinates" : [ {
          "LatAndLng" : "22.55329,113.88308",
          "Location" : "深圳市"
        },{
          "LatAndLng" : "31.40527,121.48941",
          "Location" : "上海市"
        }],
        "Reason" : "",
        "Success" : true
      }
      if(state<=1){
        data.Traces=[]
        data.Coordinates=[]
      }
      this.resData = data;
      this.tableData = data.Traces || [];
      this.tableData = this.tableData.reverse();
      this.tableData.forEach(ele=>{
          ele.AcceptTime = this.$tool.formatDate(ele.AcceptTime)
      })
    },
  },
};
</script>

<style scoped lang="scss">
@media screen and (max-width:750px) {
  .center{
    padding-top:0;
  }
}
</style>
